function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M218 105c11-11 11-29 0-40s-29-11-40 0L8 235c-11 11-11 29 0 40l171 172c11 11 29 11 40 0s11-29 0-40L69 255zm75 302c-11 11-11 29 0 40s29 11 40 0l171-172c11-11 11-29 0-40L334 65c-11-11-29-11-40 0s-11 29 0 40l149 150z"
})));